module.exports = {

    Url:
    // "https://bayin.app:4000/api/v1/"
    "https://bayin.app/api/v1/"
    // "http://3.210.140.28:6300/api/v1/"
    // "https://bayin.app:4000/api/v1/"
    // 'http://43.204.250.254:6300/api/v1/',
   
  }


  